module.exports = __webpack_public_path__ + "static/media/da-da-pling.bbe8f445.mp3";